import { Link } from 'react-router-dom';
import PageSEO from '@/components/base/PageSEO';

export default function NotFound() {
  return (
    <PageSEO
      title="页面未找到 - 17c"
      description="抱歉，您访问的页面不存在。请返回17c首页浏览其他内容。"
      keywords="17c,404,页面未找到"
    >
      <div className="min-h-screen flex items-center justify-center px-4 bg-background-50">
        <div className="text-center fade-in-up">
          <div className="text-8xl font-bold text-background-300 mb-4">404</div>
          <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
            页面未找到
          </h1>
          <p className="text-foreground-600 text-sm mb-8 max-w-md mx-auto">
            抱歉，您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页浏览其他内容。
          </p>
          <Link
            to="/"
            className="inline-flex items-center px-6 py-2.5 text-sm font-semibold rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-arrow-left-line mr-2"></i>
            返回首页
          </Link>
        </div>
      </div>
    </PageSEO>
  );
}